import React from "react";
import {InputBase} from '@material-ui/core';
import {getFontSize, getOffsetWidth} from "my-styles/media/media";
import StandardButton from "../buttons/StandardButton";

export const INPUT_TYPE = {
    NUMBER: "NUMBER",
    PHONE_NUMBER: "PHONE_NUMBER",
}

export default function IconTextView(props) {
    return (
        <div className={props.className ? props.className + " marginTopBottomXSmall" : "inputBox marginTopBottomXSmall"}
             style={{height: props.height ? props.height : "3em", position: "relative"}}>
            {props.enableRightButton ?
                <StandardButton
                    loading={props.rightButtonLoadingStatus}
                    icon={props.icon}
                    onClick={props.rightButtonOnClick}/> :
                <>{props.icon}</>
            }
            <InputBase
                type={"text"}
                key={props.key ? props.key : ""}
                disabled={props.disabled}
                onChange={props.onChange}
                onFocus={props.onFocus}
                onPaste={(event) => {
                    if (props.type) {
                        if (props.type === INPUT_TYPE.NUMBER || props.type === INPUT_TYPE.PHONE_NUMBER) {
                            if (event.clipboardData.getData('Text').length !==
                                event.clipboardData.getData('Text').replace(/[^0-9+]/g, '').length) {
                                event.preventDefault()
                            }
                        }
                    }
                }}
                onKeyDown={(event) => {
                    if (props.type) {
                        if (props.type === INPUT_TYPE.NUMBER || props.type === INPUT_TYPE.PHONE_NUMBER) {
                            if (event.key === ' ') {
                                event.preventDefault()
                            }

                            const regx = /^[0-9\b]+$/
                            if (!(event.key === '' || event.key === 'Enter' ||
                                event.key === 'Delete' || event.key === 'Backspace' ||
                                event.key === 'Shift' || event.key === 'Control' ||
                                event.key === 'Tab' || event.key === 'ArrowUp' ||
                                event.key === 'ArrowLeft' || event.key === 'ArrowDown' ||
                                event.key === 'ArrowRight' ||
                                regx.test(event.key))) {
                                event.preventDefault()
                            }

                        }
                    }

                    if (event.key === 'Enter') {
                        if (props.onEnterClick) {
                            props.onEnterClick()
                        }
                    }
                }}
                style={props.enableLeftButton ? {fontSize: getFontSize(), width: getOffsetWidth()} : {
                    fontSize: getFontSize(),
                    width: "100%"
                }}
                placeholder={props.placeholder}
                defaultValue={props.defaultValue}
                value={props.value}
                inputProps={
                    props.center ? {style: {textAlign: 'center'}} :
                        props.maxlength ? {maxLength: props.maxlength} :
                            {}
                }/>
            {props.enableLeftButton &&
            <div style={{position: "relative"}}>
                <div className="fourceCenter">
                    <StandardButton
                        textcolor={props.leftButtontextcolor}
                        loading={props.leftButtonLoadingStatus}
                        text={props.leftButtonTitle}
                        onClick={props.leftButtonOnClick}/>
                </div>
            </div>
            }
        </div>
    )
}